import { UserModel } from './user.model';

export class ComplexUserModel {
  data: UserModel[];
  total: number;
}
